import dayjs from 'dayjs';

export function calculateExpirationDate({
  subscriptionType,
  quantityUnit,
  quantity = 1,
  existingSubscription,
}) {
  let startingToCountDate = dayjs();
  if (
    existingSubscription?.status == 'active' &&
    existingSubscription?.subscriptionTypeId == subscriptionType.id &&
    dayjs().isBefore(existingSubscription?.expirationDate)
  ) {
    startingToCountDate = dayjs(existingSubscription.expirationDate);
  }
  return startingToCountDate.add(quantity, quantityUnit).toDate();
}
